module.exports = __webpack_public_path__ + "img/mobis.8393861f.png";